import { createAction } from '@lifesize/typescript-react-redux-utils';
import { FilterActionType } from '../constants/filterConstants';

const actions = {
  setFilterString: (payload: string) =>
    createAction(FilterActionType.DRILLDOWN_SET_FILTER_STRING, payload),
};

export default actions;
